<template>
    <div>
        <kgr-loading v-if="loading" />
        <div v-else>
            <br />
            <table
                v-if="childParentContribution.error === ''"
                class="kgr-table kgr-table--striped"
            >
                <thead>
                    <tr>
                        <th
                            colspan="2"
                            class="kgr-table__cell kgr-table__cell--headline"
                        >
                            {{ $t('Bitte wählen Sie aus, auf welcher Grundlage das Festsetzungsschreiben erzeugt werden soll.') }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="(contribution, key) in childParentContributions"
                        :key="key"
                        class="kgr-table__row kgr-table__row--top"
                        @click="switchContribution(key)"
                    >
                        <td class="kgr-table__cell">
                            <input
                                id="key"
                                type="radio"
                                name="contribution"
                                :checked="key === activeContribution"
                            />
                        </td>
                        <td
                            class="kgr-table__cell"
                            @click="switchContribution(key)"
                        >
                            <label :for="key">{{ contribution.name }}</label>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div
                v-else
                class="kgr-alert kgr-alert--warning kgr-row"
            >
                {{ childParentContribution.error }}
            </div>
            <br />
            <br />
            <div>
                <textarea
                    v-model="childParentContribution.textTop"
                    class="js-wysiwig kgr-input kgr-input--stateful kgr-input--top"
                ></textarea>
                <div ref="pdf_table">
                    <table class="kgr-table kgr-table--striped">
                        <tbody>
                            <tr class="kgr-table__row kgr-table__row--top">
                                <td class="kgr-table__cell">
                                    {{ $t('Gültig ab') }}
                                </td>
                                <td class="kgr-table__cell">
                                    {{ childParentContribution.dateFrom }}
                                </td>
                            </tr>
                            <tr class="kgr-table__row kgr-table__row--top">
                                <td class="kgr-table__cell">
                                    {{ $t('Name des Kindes') }}
                                </td>
                                <td class="kgr-table__cell">
                                    {{ childParentContribution.fullname }}
                                </td>
                            </tr>
                            <tr class="kgr-table__row kgr-table__row--top">
                                <td class="kgr-table__cell">
                                    {{ $t('Vertragsnummer') }}
                                </td>
                                <td class="kgr-table__cell">
                                    {{ childParentContribution.externalId }}
                                </td>
                            </tr>
                            <tr class="kgr-table__row kgr-table__row--top">
                                <td class="kgr-table__cell">
                                    {{ $t('Tägliche Betreuungszeit') }}
                                </td>
                                <td class="kgr-table__cell">
                                    {{ childParentContribution.dailyCareTime }}
                                </td>
                            </tr>
                            <tr class="kgr-table__row kgr-table__row--top">
                                <td class="kgr-table__cell">
                                    {{ $t('childParenContribution.label.income') }}
                                </td>
                                <td class="kgr-table__cell">
                                    <kgr-money :value="childParentContribution.parentIncomeOverall / 100" />
                                </td>
                            </tr>
                            <tr class="kgr-table__row kgr-table__row--top">
                                <td class="kgr-table__cell">
                                    {{ $t('Unterhaltsberechtigte Kinder') }}
                                </td>
                                <td class="kgr-table__cell">
                                    <span v-show="childParentContribution.dependentChildren >= 4">>= </span>{{ childParentContribution.dependentChildren }}
                                </td>
                            </tr>
                            <tr class="kgr-table__row kgr-table__row--top">
                                <td class="kgr-table__cell">
                                    {{ $t('Betreuungsgebühren monatlich') }}
                                </td>
                                <td class="kgr-table__cell">
                                    <kgr-money :value="childParentContribution.parentContributionMonthly" />
                                </td>
                            </tr>
                            <tr class="kgr-table__row kgr-table__row--top">
                                <td class="kgr-table__cell">
                                    {{ $t('Verpflegungskosten monatlich') }}
                                </td>
                                <td class="kgr-table__cell">
                                    <kgr-money :value="childParentContribution.foodCostMonthly" />
                                </td>
                            </tr>
                            <tr class="kgr-table__row kgr-table__row--top">
                                <td class="kgr-table__cell">
                                    {{ $t('Sonstige Gebühren pro Monat') }}
                                </td>
                                <td class="kgr-table__cell">
                                    <kgr-money :value="childParentContribution.otherCostMonthly" />
                                </td>
                            </tr>
                            <tr class="kgr-table__row kgr-table__row--top">
                                <td class="kgr-table__cell">
                                    {{ $t('Zuschüsse pro Monat') }}
                                </td>
                                <td class="kgr-table__cell">
                                    <kgr-money :value="childParentContribution.subventionMonthly" />
                                </td>
                            </tr>
                            <tr class="kgr-table__row kgr-table__row--top">
                                <td class="kgr-table__cell">
                                    {{ $t('Monatlicher Gesamtbetrag') }}
                                </td>
                                <td class="kgr-table__cell">
                                    <kgr-money :value="childParentContribution.costOverallMonthly" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <textarea
                    v-model="childParentContribution.textBottom"
                    class="kgr-input kgr-input--stateful kgr-input--bottom"
                ></textarea>
            </div>
            <div>
                <kgr-button
                    :value="$t('cancel')"
                    type="gray"
                    @click="cancel()"
                />
                <kgr-button
                    :value="$t('create.pdf')"
                    type="blue"
                    :pending="pendingCreate"
                    @click="createPdf()"
                />
            </div>
            <div class="hint">
                <kgr-note-box text-key="childParenContribution.hint" />
            </div>
        </div>
    </div>
</template>

<script>
import ChildParentContributionRepository from '../../js/repository/ChildParentContributionRepository.js';
import KgrButton from '../../components/common/form/button/KgrButton.vue';
import KgrMoney from '../../components/common/convert/Money.vue';
import Loading from '../../components/common/Loading.vue';
import NoteBox from '../../components/common/NoteBox.vue';

export default {
    components: {
        'kgr-button': KgrButton,
        'kgr-note-box': NoteBox,
        'kgr-loading': Loading,
        'kgr-money': KgrMoney,
    },
    props: {
        childId: {
            type: Number,
            required: true,
        },
        childParentIncomeId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            activeContribution: false,
            loading: true,
            childParentContribution: false,
            childParentContributions: false,
            pendingCreate: false,
        };
    },
    created() {
        ChildParentContributionRepository.get(this.childId, this.childParentIncomeId)
            .then((childParentContributions) => {
                this.childParentContributions = childParentContributions;
                this.childParentContribution = this.childParentContributions[0];
                this.loading = false;
                this.activeContribution = 0;
            })
            .catch(() => this.$notify.error('error.loadingData'));
    },
    methods: {
        switchContribution(key) {
            this.childParentContribution = this.childParentContributions[key];
            this.activeContribution = key;
        },
        cancel() {
            window.location = `/backend/child/${this.childId}/child-parent-income`;
        },
        createPdf() {
            this.pendingCreate = true;
            let text = this.childParentContribution.textTop.replace(/\r?\n/g, '<br />');
            text += this.$refs.pdf_table.innerHTML;
            text += this.childParentContribution.textBottom.replace(/\r?\n/g, '<br />');
            ChildParentContributionRepository.createPdf(this.childId, this.childParentIncomeId, text)
                .then((downloadPath) => {
                    this.$notify.success('Die Festsetzung des Elternbeitrages wurde erzeugt.');
                    this.downloadPdf(downloadPath);
                })
                .catch((error) => {
                    this.error = error;
                    this.$notify.error('saveChanges.error');
                })
                .finally(() => this.pendingCreate = false);
        },
        downloadPdf(downloadPath) {
            window.location = downloadPath;
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    .kgr-input--top {
    height: 300px;
}
.kgr-input--bottom {
    margin-top: 30px;
    height: 300px;
}
.kgr-button {
    margin-right: 10px;
}
.contribution-selection {
    float: left;
}
.hint {
    margin-top: 10px;
}
</style>
